/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-11-11T09:36:43.28
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listReportFinancialStorageContract,
	listReportFinancialStorageContractInit,
	listReportFinancialStorageContractByAuthorizations,
	deleteReportFinancialStorageContract
	
} from '@api/report/ReportFinancialStorageContract';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listReportFinancialStorageContract({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportFinancialStorageContract(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportFinancialStorageContractByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportFinancialStorageContractByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportFinancialStorageContractInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportFinancialStorageContractInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteReportFinancialStorageContract({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteReportFinancialStorageContract({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
